module.exports = "i{\r\n    cursor: pointer;\r\n}\r\n.btn-outline-primary {\r\n    color: #0a58d5;\r\n    border-color: #0a58d5;\r\n    border-width: 2px;\r\n}\r\n.btn-outline-primary:hover{\r\n    color: white;\r\n    background-color: #0a58d5;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/gridview/gridview.component.css
// module id = ./src/app/gridview/gridview.component.css
// module chunks = main